// extracted by mini-css-extract-plugin
export default {"barLabel":"task-list_barLabel__Hi1Ge","barLabelOutside":"task-list_barLabelOutside__VF9yP"};